import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'

import Heading from '~/client/components/Heading'

export default function SecurityPage() {
  return <Container>
    <Paper sx={{p: 2, m: 2, maxWidth: 'sm', mx: 'auto'}} >
      <Heading variant="main">Security</Heading>
      <p>
        The DataPal uses cutting edge cryptography to keep your
        data safe.
      </p>
      <p>
        When DataPal v1 launches all of your data will be encrypted
        and invisible to us.
      </p>
    </Paper>
  </Container>
}
